module.exports = __webpack_public_path__ + "static/media/ic-add-blue.ef31254b.svg";